import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FileText, TrendingUp, Settings, HelpCircle, Menu, X } from 'lucide-react';
import { cn } from '../../utils/cn';

const navItems = [
    { icon: FileText, label: 'Bonds', path: '/bonds' },
    { icon: TrendingUp, label: 'Investment', path: '/investment' },
];

const footerItems = [
    { icon: Settings, label: 'Settings', path: '/settings' },
    { icon: HelpCircle, label: 'Help & Support', path: '/help' },
];

export const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* Mobile Overlay */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 z-20 lg:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Hamburger Menu Button (Mobile) */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="fixed top-4 left-4 z-[60] lg:hidden p-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors shadow-lg"
            >
                {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>

            {/* Sidebar */}
            <aside
                className={cn(
                    'w-64 bg-slate-900 text-white flex flex-col h-screen fixed left-0 top-0 z-30 transition-transform duration-300',
                    'lg:translate-x-0',
                    isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
                )}
            >
                {/* Logo */}
                <div className="p-6 border-b border-slate-800">
                    <div className="flex items-center gap-3">
                        {/* <div className="h-8 w-8 bg-primary-500 rounded-lg flex items-center justify-center">
                            <FileText className="h-5 w-5 text-white" />
                        </div> */}
                        <span className="font-bold text-lg tracking-tight">Investment Analysis Engine</span>
                    </div>
                </div>

                {/* Navigation */}
                <nav className="flex-1 p-4 space-y-2">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
                            className={({ isActive }) =>
                                cn(
                                    'flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200',
                                    isActive
                                        ? 'bg-primary-600 text-white shadow-lg shadow-primary-900/20'
                                        : 'text-slate-400 hover:text-white hover:bg-slate-800'
                                )
                            }
                        >
                            <item.icon className="h-5 w-5" />
                            <span className="font-medium">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                {/* Footer */}
                <div className="p-4 border-t border-slate-800 space-y-2">
                    {footerItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => window.innerWidth < 1024 && setIsOpen(false)}
                            className={({ isActive }) =>
                                cn(
                                    'flex items-center gap-3 px-4 py-3 w-full rounded-lg transition-colors',
                                    isActive
                                        ? 'bg-primary-600 text-white'
                                        : 'text-slate-400 hover:text-white hover:bg-slate-800'
                                )
                            }
                        >
                            <item.icon className="h-5 w-5" />
                            <span className="font-medium">{item.label}</span>
                        </NavLink>
                    ))}
                </div>
            </aside>
        </>
    );
};
